import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { getNameFIle } from '../../../util/util';

@Component({
    selector: 'app-attachment-to-sign',
    templateUrl: './attachment-to-sign.component.html',
    styleUrls: ['./attachment-to-sign.component.scss'],
    standalone: false
})
export class AttachmentToSignComponent implements OnInit {
	@Output() sendingFiles = new EventEmitter<any>();
	@ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
	@Input() hideNoteField: boolean = false;
	@Input() accept: string = '*';
	files: any [] = [];
	showTable: boolean = false;
	// var for messages
	errorMessage: string = '';
	successMessage: string = '';
	private _success = new Subject<string>();
	private _error = new Subject<string>();
  constructor() { }

  ngOnInit() {
		this.messageErrorSuccess();
  }

	/* THIS IS FOR LOADING FILES */
	// on file drop handler
  onFileDropped($event) {
    this.prepareFilesList($event);
  }
  // handle file from browsing
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
	}
	// delete the files by index and using a splice() method
	deleteFile(index: number) {
		this.files.splice(index, 1);
		this._success.next('Se elimino correctamente.');
		if (this.files.length <= 0) {
			this.showTable = false;
		}
		this.sendingFiles.emit(this.files);
  }
	prepareFilesList(files: Array<any>) {
		/* const result = this.validationFiles(files);
		if ( result ) { */
		this.showTable = true;
		for (const item of files) {
				item.note = '';
				this.files.push(item);
		}
		this.sendingFiles.emit(this.files);
		// this.noteValueEl.nativeElement.value = "";
		this.fileDropEl.nativeElement.value = "";
		getNameFIle(this.files)
		/* } else {
			this._error.next('Error: Ya se cargo el archivo!!');
		} */
	}
	messageErrorSuccess() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessage = '');
	}
}
